import styled from 'styled-components';
import { CircleAlertIcon } from '@ids/internal-icons';

export const Wrapper = styled.span`
  display: flex;
  font-size: 14px;
  line-height: 20px;
  opacity: 1;
  margin-top: 8px;
  margin-bottom: 4px;
  font-style: normal;
`;

export const Text = styled.span`
  ${props =>
    props.type === 'error' && props.message !== '' && `color: #d52b1e;`};
  ${props =>
    props.type === 'warning' && props.message !== '' && `color: #ff6a00;`};
`;

export const ErrWarningIcon = styled(CircleAlertIcon)`
  ${props =>
    props.type === 'warning' &&
    `
    height: 16px;
    width: 16px;
    margin-top: 2px;
    margin-right: 8px;
    fill: #ff6a00;
  `};
  ${props =>
    props.type === 'error' &&
    `
    height: 16px;
    width: 16px;
    margin-top: 2px;
    margin-right: 8px;
    fill: #d52b1e;
  `};
`;
